module.exports = __webpack_public_path__ + "static/media/Boshonto-Backdrop_16ftX10ft.4e3e734e.jpg";